
/*
 * Copyright (c) 2021 by Leyton Group - All Rights Reserved.
 *  This source code, and resulting software, is the confidential and proprietary information
 *  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
 *  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
 *  and shall use it only in accordance with the terms and conditions of any and all license
 *  agreements you have entered into with The Company.
 */

import moment from "moment";
import { find } from "lodash";
import {constants} from "@/shared/constants";

const DATE_FORMAT = 'YYYY-MM-DD';

export const estimationMapper = {
    mapAddresses,
    mapFiches
};

function mapAddresses(estimation, tabAddressIndex) {
    return {
        tabAddressIndex: tabAddressIndex,
        id: estimation.address.id,
        workAddress: estimation.address.addressNumber,
        way: estimation.address.addressRoad,
        additionalInfo: estimation.address.additionalAddress,
        zipCode: estimation.address.postalCode,
        departmentCode: getDepartmentCode(estimation.address.postalCode),
        city: estimation.address.city,
        climateZone: getClimateZone(estimation.address.postalCode),
        cities: estimation.address.cities
    };
}

function getDepartmentCode(zipCode) {
    const _departementLength = 2;
    return zipCode.substring(0, _departementLength);
}

function getClimateZone(zipCode) {
    const departmentCode = getDepartmentCode(zipCode);
    return departmentCode ? constants.DEPARTEMENTS.find(value => value.code === departmentCode).zone : '';
}

function mapFiches(operationDetail, address, periods, tabAddressIndex, tabFicheIndex) {
    return {
        addressIndex: tabAddressIndex,
        tabFicheIndex: tabFicheIndex,
        id: operationDetail.operation.id,
        provisionalBeginDate: setProvisionalBeginDate(operationDetail.operation.beginDate),
        provisionalCompletionDate: setProvisionalCompletionDate(operationDetail.operation.endDate),
        workType: operationDetail.operation.fiche.type,
        activityArea: operationDetail.operation.fiche.applicationSector,
        ficheNumber: operationDetail.operation.fiche.id,
        departmentCode: address.departmentCode,
        climateZone: address.climateZone,
        precarityControl: setPrecarityControl(operationDetail.operation.ficheCalcul.precarity),
        workTypes: setWorkTypesBySector(operationDetail.operation.fiche.applicationSector),
        fiches: operationDetail.fiches,
        fiche: operationDetail.operation.fiche,
        conditions: setConditions(operationDetail.operation.ficheCalcul.conditions),
        calculFormula: setCalculFormula(operationDetail.operation.ficheCalcul, operationDetail.operation),
        period: setPeriod(periods, operationDetail.operation.beginDate),
        ficheEmmiesRemaining: operationDetail.operation.ficheEmmiesRemaining
    };
}

function setProvisionalBeginDate(beginDate) {
    return beginDate ? moment(beginDate , 'x').format(DATE_FORMAT) : null;
}
function setProvisionalCompletionDate(endDate) {
    return endDate ? moment(endDate , 'x').format(DATE_FORMAT) : null;
}
function setWorkTypesBySector(sector) {
    return constants.APPLICATION_SECTORS.find(s => s.value === sector).types;
}
function setPrecarityControl(precarity) {
    return {
        bigPrecarity: precarity.bigPrecarity,
        precarity: precarity.precarityCase,
        coupleNumber: precarity.coupleNumber,
        coupleNumberInSocialHousing: precarity.coupleNumberInSocialHousing,
        couplePercentagePrecarity: precarity.couplePercentagePrecarity,
        couplePercentageBigPrecarity: precarity.couplePercentageBigPrecarity,
        coupleNumberPrecarity: precarity.coupleNumberPrecarity,
        coupleNumberBigPrecarity: precarity.coupleNumberBigPrecarity,
        id: precarity.precarite ? precarity.precarite.id : null,
        periodId: precarity.precarite ? precarity.precarite.periodID : null,
        department: precarity.precarite ? precarity.precarite.departementCode : null,
        couplePercentagePrecarityByDepartment: precarity.precarite ? precarity.precarite.percentHigh : null,
        couplePercentageBigPrecarityByDepartment: precarity.precarite ? precarity.precarite.percentLow : null,
    }
}
function setPeriod(periods, provisionalBeginDate) {
    let period = {}
    periods.forEach(prd => {
        const beginDate = moment(prd.beginDate, 'DD-MM-YYYY hh:mm:ss');
        const endDate = moment(prd.endDate, 'DD-MM-YYYY hh:mm:ss');
        if (moment(setProvisionalBeginDate(provisionalBeginDate), DATE_FORMAT).isBetween(beginDate, endDate)) {
            period = prd;
        }
    })
    return period;
}

function setConditions(ficheCalculConditions) {
    const conditions = []
    ficheCalculConditions.forEach(ficheCondition => {
        ficheCondition.emmy.value = ficheCondition.condition.value;
        conditions.push(ficheCondition);
    })
    return conditions;
}

function setCalculFormula(ficheCalcul, operationDetail) {
    ficheCalcul.items.forEach( item => {
        const calculationItems = item.calculationItems;
        calculationItems.forEach(calculationItem => {
            find(item.ficheCalculItemFicheEmmies, {ficheEmmy: {id: calculationItem.ficheEmmy.id}})
                .ficheEmmy.emmy.value = calculationItem.value ?
                calculationItem.value : calculationItem.selectedValue.value;
        })
    })
    ficheCalcul.ficheEmmiesRemaining = operationDetail.ficheEmmiesRemaining;
    ficheCalcul.ficheEmmies = operationDetail.ficheEmmiesRemaining.map(ficheEmmyRemaining => ({
        emmy: {...ficheEmmyRemaining.ficheEmmy.emmy, value: ficheEmmyRemaining.text},
        id: ficheEmmyRemaining.ficheEmmy.id
    }));
    return ficheCalcul;
}
